'use client';

import { useMemo } from 'react';

import { type UseSalsifyContentProps, useSalsifyContent } from './use-salsify-content';
import { useWebcollage } from './use-webcollage';

export type UseSalsifyProps = UseSalsifyContentProps;

export function useSalsify({ salsifyClientId, salsifyIdType, productId }: UseSalsifyProps) {
    const salsifyFound = useSalsifyContent({ productId, salsifyClientId, salsifyIdType });
    const { initializeWebcollage, webCollageFound } = useWebcollage(productId);

    return useMemo(
        () => ({ initializeWebcollage, webCollageFound, salsifyFound }),
        [initializeWebcollage, webCollageFound, salsifyFound]
    );
}
